import { createIcon } from '@chakra-ui/react';

export const ChangeEvent = createIcon({
  displayName: 'ChangeEvent',
  viewBox: '0 0 24 24',
  path: (
    <g id="SJ-Icon-B_FindEvent_Red_RGB" transform="translate(0.375 1.125)">
      <path
        id="Path_2167"
        data-name="Path 2167"
        d="M21.813,4.78H19.187V3.562a.563.563,0,0,0-1.125,0V4.78H7.188V3.562a.563.563,0,0,0-1.125,0V4.78H3.438A2.44,2.44,0,0,0,1,7.218V22.312a2.44,2.44,0,0,0,2.438,2.438H21.813a2.44,2.44,0,0,0,2.438-2.437V7.218A2.44,2.44,0,0,0,21.813,4.78Zm0,18.844h-8.29c.907-1.875,3.11-6.445,3.68-7.747a5.2,5.2,0,0,0,.452-2.087,5.029,5.029,0,0,0-10.057,0,5.2,5.2,0,0,0,.452,2.087h0c.522,1.2,2.41,5.122,3.679,7.747H3.438a1.314,1.314,0,0,1-1.312-1.312V10.03h5.93a.563.563,0,0,0,0-1.125H2.125V7.218A1.314,1.314,0,0,1,3.438,5.905H6.063V7.124a.563.563,0,0,0,1.125,0V5.905H18.062V7.124a.563.563,0,0,0,1.125,0V5.905h2.626a1.314,1.314,0,0,1,1.313,1.313V8.905H17.2a.563.563,0,0,0,0,1.125h5.93V22.312A1.314,1.314,0,0,1,21.813,23.624ZM12.626,22.9c-1.882-3.9-3.164-6.6-3.545-7.468a4.089,4.089,0,0,1-.358-1.637,3.9,3.9,0,0,1,7.807,0,4.085,4.085,0,0,1-.358,1.637C15.633,16.658,13.587,20.907,12.626,22.9Z"
        transform="translate(-1 -2.999)"
        fill="currentColor"
      />
      <path
        id="Path_2168"
        data-name="Path 2168"
        d="M28.743,26.569A1.955,1.955,0,1,0,30.7,28.524,1.957,1.957,0,0,0,28.743,26.569Zm0,2.784a.83.83,0,1,1,.829-.83A.83.83,0,0,1,28.743,29.353Z"
        transform="translate(-17.118 -17.73)"
        fill="currentColor"
      />
    </g>
  ),
});
